import { render, staticRenderFns } from "./CompareProductWithChart.vue?vue&type=template&id=ec54553a"
import script from "./CompareProductWithChart.vue?vue&type=script&lang=js"
export * from "./CompareProductWithChart.vue?vue&type=script&lang=js"
import style0 from "./CompareProductWithChart.vue?vue&type=style&index=0&id=ec54553a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports